import { threeDStudioStore } from '../index'

const setViewerState = (patch) => {
  threeDStudioStore.setState((state) => ({
    viewer: { ...state.viewer, ...patch },
  }))
}

/**
 * Sets the viewer file format
 * @param {string} fileFormat - The file format to set
 */
export const setViewerFileFormat = (fileFormat) => {
  setViewerState({ fileFormat })
}

/**
 * Sets the viewer file size
 * @param {number} fileSize - The file size to set
 */
export const setViewerFileSize = (fileSize) => {
  setViewerState({ fileSize })
}

/**
 * Mirrors the viewer's mesh/segment list into the store so the viewer sidebar
 * (rendered outside the ViewerContext) can read it.
 * @param {Array} meshList - MeshInfo[] from viewer.getMeshList()
 */
export const setViewerMeshList = (meshList) => {
  setViewerState({ meshList })
}

/**
 * Mirrors whether the loaded model is rigged into the store.
 * @param {boolean} isRigged - viewer.isModelRigged(modelId)
 */
export const setViewerIsRigged = (isRigged) => {
  setViewerState({ isRigged })
}

/**
 * Mirrors the exploded-view enabled flag into the store.
 * @param {boolean} explodedViewEnabled - viewer.getExplodedViewSettings().enabled
 */
export const setViewerExplodedEnabled = (explodedViewEnabled) => {
  setViewerState({ explodedViewEnabled })
}

/**
 * Mirrors whether the viewer offers the segmentation render mode (it becomes
 * available once the loaded model has at least two meshes).
 * @param {boolean} segmentationRenderModeAvailable - renderMode.availableModes.has('segmentation')
 */
export const setViewerSegmentationRenderModeAvailable = (segmentationRenderModeAvailable) => {
  setViewerState({ segmentationRenderModeAvailable })
}

/**
 * Mirrors the id of the mesh currently selected in the 3D viewer so the part
 * list can highlight the matching row.
 * @param {string|null} selectedMeshId - viewer.getSelectionSettings().selectedMeshId
 */
export const setViewerSelectedMeshId = (selectedMeshId) => {
  setViewerState({ selectedMeshId })
}

